import { UserState } from './useUserStore';

export const selectUser = (state: UserState) => state.user;
